import { SubText } from '@procurify/ui'

import { type ConversationCatalogItemDelivery } from '../../value-objects/ConversationTurnItem'
import { ConversationMarkdown } from '../ConversationMarkdown'

export interface ICatalogItemDeliveryLabelProps {
  delivery: ConversationCatalogItemDelivery
  noWrap?: boolean
}

export const CatalogItemDeliveryLabel = ({
  delivery,
  noWrap = false,
}: ICatalogItemDeliveryLabelProps) => (
  <SubText inline noWrap={noWrap} color='textSecondary'>
    <ConversationMarkdown content={delivery.label} isInline />
  </SubText>
)
